import { Fade, Link as MuiLink, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { useFindKundeByIdQuery } from '../api/kundeApi';

export function KundeLink({ id, label }: { id: string; label?: string }) {
  const { data: kunde } = useFindKundeByIdQuery(id);

  const linkElement = (
    <Fade in={Boolean(kunde)}>
      <MuiLink
        component={RouterLink}
        to={`/intern/kunde/${id}`}
        color="secondary"
        onClick={(e: React.SyntheticEvent) => e.stopPropagation()}
      >
        {kunde?.organisation}
      </MuiLink>
    </Fade>
  );

  return label ? (
    <Typography
      variant="caption"
      sx={{
        color: 'text.secondary',
      }}
    >
      {label}
      <Typography
        variant="body1"
        sx={{
          color: 'text.primary',
        }}
      >
        {linkElement}
      </Typography>
    </Typography>
  ) : (
    linkElement
  );
}
